
import * as api from '../api';
import axios from 'axios';
// import router from '../routerManuaConfig'
import Vue from 'vue';
let base = api.BaseApiUrl;
//医疗机构模块管理
export const getMedicalListPage = params => {
  return axios.get(`${base}/api/MedicalOrganization/get`, { params: params });
};

export const addMedical = params => {
  return axios.post(`${base}/api/MedicalOrganization/Addmedical`, params);
};

export const RemoveMedical = params => {
  return axios.get(`${base}/api/MedicalOrganization/DeleteMedicalByid`, { params: params });
};

export const GetMediOpion = params => {
  return axios.get(`${base}/api/MedicalOrganization/GetMedicalidandName`, { params: params });
};
export const editMedical = params => {
  return axios.post(`${base}/api/MedicalOrganization/Putmedical`, params);
};
export const Getmedcialbyid = params => {
  return axios.get(`${base}/api/MedicalOrganization/GetMedicalById`, { params: params });
};
export const Getmedicallist = params => {
  return axios.get(`${base}/api/MedicalOrganization/GetMedicallist`, { params: params });
};